window.addEventListener('load', () => {
  const $modal = $('#switch-report-modal');

  if ($modal.length === 0) {
    return;
  }

  // switch_reportパラメータがtrueの場合、画面描画時にモーダル表示
  let url = new URL(window.location.href);
  let params = url.searchParams;
  if (params.get('switch_report') === 'true') {
    $modal.modal('show');
  }

  const selectDomClass = '.image-container';
  const $initial = $modal.find(`${selectDomClass}.active`);
  let $current = $initial;

  const setActiveItem = ($item) => {
    const $prev = $current;
    $current = $item;
    $prev.removeClass('active');
    $prev.find('input[type="radio"]').prop('checked', false);
    $current.addClass('active');
    $current.find('input[type="radio"]').prop('checked', true);
    return $current;
  };

  const setLocation = (href) => {
    if (href && location.href !== href) {
      location.href = href;
    }
  };

  $modal.find('input[type="radio"]').on('change', (event) => {
    setActiveItem($(event.target).closest(selectDomClass), true);
  });

  $modal.find(selectDomClass).on('click', (event) => {
    setActiveItem($(event.target).closest(selectDomClass));
  });

  $modal.find('.modal-footer .btn-primary').on('click', (_event) => {
    $modal.modal('hide');
    setLocation($current.data('href'));
  });

  $modal.find('.modal-footer .btn-secondary').on('click', (_event) => {
    $modal.modal('hide');
  });

  $modal.on('hidden.bs.modal', (_event) => {
    setActiveItem($initial);
  });
});
